module.exports = __webpack_public_path__ + "media/images/icons/flags/IR-b0980a25fb3618849e280584c6b06d36.svg";